module.exports = __webpack_public_path__ + "img/casablanca (6).80093b83.jpg";